import { COLOR_PER_DOG_BREEDER_LAST_CONNECTED_TYPE } from '@presentation/constants';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { TbArrowNarrowRight, TbExternalLink } from 'react-icons/tb';
import { Avatar, Button, InputCheckboxField, Label } from '..';
import * as Styled from './styled';
import type { ApplicationsSuggestionTableProps } from './types';

export * from './types';

export const ApplicationsSuggestionTable: FC<ApplicationsSuggestionTableProps> = (props) => {
  const { translate } = useTranslation();
  const { translate: translateRessource } = useTranslation({
    keyPrefix: 'common.sections.applicationsSuggestion.table',
  });
  const {
    rows,
    onSuggestedBreederClick,
    showSkipButton = false,
    canSubmit = true,
    isSubmitting = false,
  } = props;

  return (
    <>
      <Styled.Table>
        <Styled.TableHead>
          <Styled.TableCell>{translateRessource('breeder')}</Styled.TableCell>
          <Styled.TableCell>{translateRessource('raisedBreeds')}</Styled.TableCell>
          <Styled.TableCell>{translateRessource('pedigree')}</Styled.TableCell>
          <Styled.TableCell>{translateRessource('activity')}</Styled.TableCell>
          <Styled.TableCell />
        </Styled.TableHead>

        {rows?.map((row, index) => (
          <Styled.TableRow key={index}>
            <Styled.TableRowLabel htmlFor={`${index}-${row.breedName}`} />
            <Styled.TableCell data-title={translateRessource('breeder')}>
              <Styled.ImageNameWrapper>
                <Avatar size={48} src={row.image} />
                <Button
                  iconRight={<TbExternalLink />}
                  onClick={
                    onSuggestedBreederClick ? () => onSuggestedBreederClick(row.id) : undefined
                  }
                  externalLink={!onSuggestedBreederClick ? row.link : undefined}
                >
                  {row.name}
                </Button>
              </Styled.ImageNameWrapper>
            </Styled.TableCell>
            <Styled.TableCell data-title={translateRessource('raisedBreeds')}>
              <Styled.BreedNameWrapper>{row.breedName}</Styled.BreedNameWrapper>
            </Styled.TableCell>
            <Styled.TableCell data-title={translateRessource('pedigree')}>
              {row.pedigree}
            </Styled.TableCell>
            <Styled.TableCell data-title={translateRessource('activity')}>
              {row.lastConnectedBadgeType && (
                <Label
                  content={translate(`enum.lastConnectedType.${row.lastConnectedBadgeType}`)}
                  theme={COLOR_PER_DOG_BREEDER_LAST_CONNECTED_TYPE[row.lastConnectedBadgeType]}
                />
              )}
            </Styled.TableCell>
            <Styled.TableCell>
              <InputCheckboxField
                id={`${index}-${row.breedName}`}
                name={`selectedBreeders[${index}]`}
              />
            </Styled.TableCell>
          </Styled.TableRow>
        ))}
      </Styled.Table>

      <Styled.ButtonWrapper>
        {showSkipButton && (
          <Button type="submit" outlined color="blue" shrink>
            {translate('common.buttons.skip')}
          </Button>
        )}

        <Button
          type="submit"
          shrink
          color="blue"
          iconRight={<TbArrowNarrowRight />}
          loading={isSubmitting}
          disabled={!canSubmit}
        >
          {translate('common.buttons.send')}
        </Button>
      </Styled.ButtonWrapper>
    </>
  );
};
